import { ActionIcon, Button, Skeleton, Text } from "@mantine/core";

import { IconChevronLeft, IconChevronRight } from "@/components/icons";

import type { MantineStyleProps } from "@mantine/core";
import type { FC } from "react";

export type ListTablePaginationProps = {
  divider?: string;
  loading?: boolean;
  onChange: (page: number) => void;
  page: number;
  pageSize?: number;
  total?: number;
} & MantineStyleProps;

export const ListTablePagination: FC<ListTablePaginationProps> = ({
  divider = "/",
  loading = false,
  onChange,
  page,
  pageSize = 25,
  total = 0,
  ...props
}) => {
  const firstItem = (page - 1) * pageSize + 1;
  const lastItem = Math.min((page - 1) * pageSize + pageSize, total);

  const hasPrev = page > 1;
  const hasNext = lastItem < total;

  return (
    <Button.Group {...props}>
      <Button.GroupSection variant="default">
        <Skeleton visible={loading}>
          <Text size="sm">
            <Text component="span" fw={500}>
              {firstItem}-{lastItem}
            </Text>
            <Text component="span" c="secondary.5">
              {divider}
              {total}
            </Text>
          </Text>
        </Skeleton>
      </Button.GroupSection>
      <Button.GroupSection variant="default" px={0}>
        <ActionIcon variant="transparent" disabled={!hasPrev} onClick={() => onChange?.(page - 1)}>
          <IconChevronLeft size={24} />
        </ActionIcon>
        <ActionIcon variant="transparent" disabled={!hasNext} onClick={() => onChange?.(page + 1)}>
          <IconChevronRight size={24} />
        </ActionIcon>
      </Button.GroupSection>
    </Button.Group>
  );
};
